const en = {
  brand: {
    name: 'POWER',
    desc: 'AUTO SERVICE',
  },

  nav: {
    services: 'Services',
    prices: 'Prices',
    about: 'About',
    contacts: 'Contacts',
    contactUs: 'Contact Us',
    workHours: 'Daily 10:00–19:00',
  },

  hero: {
    badge: '⭐ Over 10 years in the auto service market',
    title1: 'Professional',
    titleAccent: ' auto service',
    title2: 'in Ulaanbaatar',
    text: 'We perform all types of repair and maintenance of vehicles of all brands. 1-year warranty on work. Modern equipment and experienced mechanics.',
    stat1num: '12,000+',
    stat1label: 'happy clients',
    stat2num: '10+',
    stat2label: 'years of experience',
    stat3num: '1',
    stat3label: 'year warranty',
    btnBooking: 'Book a Repair',
    btnPrices: 'View Prices',
    card1title: 'Free Diagnostics',
    card1text: 'for repairs over 5,000 ₽',
    card2title: 'Original Parts',
    card2text: 'delivery in 1-2 days',
    card3title: 'Urgent Repair',
    card3text: 'same day service',
  },

  services: {
    title: 'Our Services',
    subtitle: 'Full range of car repair and maintenance services for all brands',
    more: 'Learn more →',
  },

  advantages: {
    title: 'Why Choose Us',
    subtitle: 'We provide reliable, high-quality, and guaranteed services for your vehicle in a fast, efficient, and comfortable manner, ensuring your car’s safety.”',
    items: [
      { icon: '🕐', title: 'Fast Repair', text: 'Most work is completed on the same day. Complex repairs — 1 to 3 days.' },
      { icon: '💎', title: '1 Year Warranty', text: 'Warranty on all types of work performed.' },
      { icon: '📋', title: 'Transparent Prices', text: 'We agree on the cost before starting work. No hidden fees.' },
      { icon: '🚗', title: 'All Car Brands', text: 'We work with vehicles of all makes: from budget to premium.' },
      { icon: '🔧', title: 'Professional Equipment', text: 'Modern stands, scanners and tools from leading manufacturers.' },
      { icon: '📱', title: 'Online Booking', text: 'Book at a convenient time through the website or messenger in 1 minute.' },
    ],
  },

  about: {
    title: 'About Our Auto Service',
    text1: 'Power auto service is a modern full-cycle auto service in Ulaanbaatar. We have been operating since 2016 and have serviced over 12,000 vehicles.',
    text2: 'Our specialists undergo regular training and constantly improve their qualifications. We use only professional equipment and original parts.',
    features: [
      { icon: '🏆', title: 'Certified Center', text: 'Licenses and certificates for all types of work' },
      { icon: '👥', title: 'Experienced Team', text: 'Average mechanic experience — over 8 years' },
      { icon: '🔒', title: 'Quality Guarantee', text: '1 year warranty on work' },
      { icon: '💰', title: 'Honest Prices', text: 'No hidden fees or imposed services' },
    ],
    yearsLabel: 'years of work',
    imageTitle: 'Our Auto Service',
  },

  prices: {
    title: 'Service Prices',
    subtitle: 'Current prices for main types of work. Exact cost should be confirmed after diagnostics.',
    headerWork: 'Type of Work',
    headerPrice: 'Price',
    note: 'Prices shown are for labor only, excluding parts. The exact cost will be calculated by the mechanic after diagnostics.',
    rateDisclaimer:
      'Prices in US dollars are converted from tugriks (₮) at the official Bank of Mongolia exchange rate and may change when the rate is updated.',
  },

  booking: {
    title: 'Book a Repair',
    text: 'Leave a request and we will call you back shortly to clarify details and select a convenient time.',
    benefit1: 'Free diagnostics with repair',
    benefit2: 'We call back shortly',
    benefit3: 'Fixed price after inspection',
    benefit4: 'Warranty on all work',
    orCall: 'Or call us:',
    nameLabel: 'Your Name',
    namePlaceholder: 'John Smith',
    phoneLabel: 'Phone',
    carLabel: 'Car Make and Model',
    carPlaceholder: 'TOYOTA Land Cruiser 200 2020',
    serviceLabel: 'Service',
    serviceDefault: 'Select a service',
    dateLabel: 'Preferred Date',
    commentLabel: 'Comment',
    commentPlaceholder: 'Describe the problem or your wishes...',
    submit: '📋 Submit Request',
    sending: 'Sending...',
    privacy: 'By clicking the button, you agree to the personal data processing policy',
  },

  carousel: {
    title: 'Frequent Guests at Our Service',
    subtitle: 'Vehicles that are regularly serviced with us',
    imageAlt: 'Vehicle',
    items: [
      'TOYOTA Land Cruiser Prado 120',
      'TOYOTA Land Cruiser Prado 150',
      'TOYOTA Hilux 185',
      'TOYOTA Hilux 215',
      'LEXUS RX 450',
      'TOYOTA Land Cruiser 200',
    ],
  },

  gallery: {
    title: 'Our Auto Service',
    subtitle: 'Modern equipment and comfortable conditions',
    items: [
      { emoji: '🔧', title: 'Repair Zone' },
      { emoji: '🖥️', title: 'Diagnostics' },
      { emoji: '🏗️', title: 'Lifts' },
      { emoji: '🛞', title: 'Tire Service' },
      { emoji: '⚙️', title: 'Waiting Area' },
      { emoji: '🧰', title: 'Tools' },
    ],
  },

  contacts: {
    title: 'Contacts',
    subtitle: 'Visit us or get in touch via any convenient method',
    address: 'Address',
    addressValue: 'Ulaanbaatar, SBD, 12 committee, 32 district',
    phone: 'Phone',
    phone2: 'Phone 2',
    email: 'Email',
    schedule: 'Working Hours',
    weekdays: 'Open daily, no days off: 10:00 AM — 7:00 PM',
    nightSurcharge:
      'Night-shift call-out — additional 200,000 ₮ on top of the service price.',
    map: 'Map',
    mapHint: 'Insert Yandex/Google Map here',
  },

  contact: {
    title: 'Contact Us',
    subtitle: 'Choose a convenient way to get in touch',
    callTitle: 'Call Us',
    callDesc: 'Get in touch with us right now',
    formTitle: 'Leave Your Contacts',
    formDesc: 'We will call you back shortly',
    formTag: 'We respond shortly',
    orWrite: 'Or write to us via messenger:',
    back: 'Back',
    leaveContacts: 'Leave Your Details',
    leaveContactsDesc: 'Our manager will receive a notification and contact you',
    nameLabel: 'Your Name',
    namePlaceholder: 'John Smith',
    phoneLabel: 'Phone',
    preferredContact: 'How to reach you?',
    byPhone: 'Phone Call',
    tgUsernameLabel: 'Your Telegram username',
    tgUsernamePlaceholder: '@username',
    tgUsernameHint: 'Your Telegram username so we can message you',
    messageLabel: 'Message',
    messagePlaceholder: 'Describe your question or problem...',
    sendButton: '📨 Send Request',
    sending: 'Sending...',
    privacy: 'By clicking the button, you agree to the personal data processing',
    errorRequired: 'Please fill in the required fields',
    errorPhone: 'Please enter the full phone number',
    errorTgUsername: 'Please enter your Telegram username',
    errorTgUsernameShort: `Username is too short (minimum 3 characters)`,
    errorSend: 'Sending error. Please try calling us.',
    successTitle: 'Request Sent!',
    successDesc: 'Our manager will contact you shortly.',
    close: 'Close',
  },

  footer: {
    about: 'Professional full-cycle auto service in Ulaanbaatar. Repair and maintenance of all car brands with warranty.',
    servicesTitle: 'Services',
    svcDiag: 'Vibration diagnostics',
    svcComputer: 'Computer diagnostics',
    svcBalance: 'Wheel balancing',
    svcAlignment: 'Wheel alignment',
    svcOil: 'Engine oil change',
    infoTitle: 'Information',
    aboutCompany: 'About Company',
    privacyPolicy: 'Privacy Policy',
    contactsTitle: 'Contacts',
    copyright: 'All rights reserved.',
    disclaimer: 'The website is for informational purposes only and does not constitute a public offer.',
  },

  videos: {
    title: 'Videos from Our Service',
    subtitle: 'See how we work',
    items: [
      { id: 'kuTJUYci3c4', title: 'Vibration diagnostics of the engine' },
      { id: 'MsfwwIzWCGw', title: 'Diagnostics' },
      { id: '9FR1oo2qM5g', title: 'Car computer diagnostics' },
      { id: 'ocncIUsGCsM', title: 'Wheel balancing service' },
      { id: 'L7V6p91ZIKE', title: 'Wheel alignment' },
    ],
  },

  parts: {
    toggleBtn: 'Parts Prices by Car Model',
    oilsLabel: 'Oils & Filters',
    partsLabel: 'Suspension Parts',
    headerName: 'Part Name',
    headerQty: 'Qty',
    headerBrand: 'Brand',
    headerPrice: 'Price per unit',
    disclaimer: 'Prices are approximate and valid for 2026. Final cost depends on diagnostics results. Most parts purchased from us include free installation.',
    rateDisclaimer:
      'Prices in US dollars are converted from tugriks (₮) at the official Bank of Mongolia exchange rate and may change when the rate is updated.',
  },

  servicePage: {
    back: '← Back to Home',
    pricesTitle: 'Service Prices',
  },

};

export default en;
